var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.45 17C12.7538 17 13 17.4477 13 18C13 18.5523 12.7538 19 12.45 19H2.55C2.24624 19 2 18.5523 2 18C2 17.4477 2.24624 17 2.55 17H12.45ZM21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H21ZM21 5C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H21Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.404 18L20.9162 16.4878C21.0279 16.3761 21.0279 16.1955 20.9162 16.0838C20.8045 15.9721 20.6239 15.9721 20.5122 16.0838L19 17.596L17.4878 16.0838C17.3761 15.9721 17.1955 15.9721 17.0838 16.0838C16.9721 16.1955 16.9721 16.3761 17.0838 16.4878L18.596 18L17.0838 19.5123C16.9721 19.624 16.9721 19.8046 17.0838 19.9163C17.1395 19.972 17.2126 20 17.2858 20C17.3589 20 17.4321 19.972 17.4878 19.9163L19 18.404L20.5122 19.9163C20.5679 19.972 20.6411 20 20.7142 20C20.7874 20 20.8605 19.972 20.9162 19.9163C21.0279 19.8046 21.0279 19.624 20.9162 19.5123L19.404 18Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerClose);
export default __webpack_public_path__ + "static/media/hamburgerClose.458991cb.svg";
export { ForwardRef as ReactComponent };